import React from 'react';

function Breadcrumbs({ songName, onBack }) {
  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      <button className="breadcrumb-btn home-btn" onClick={onBack} aria-label="Home">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
          <polyline points="9 22 9 12 15 12 15 22" />
        </svg>
      </button>
      <span className="breadcrumb-separator">&gt;</span>
      <button className="breadcrumb-btn" onClick={onBack}>Songs</button>
      <span className="breadcrumb-separator">/</span>
      <span className="breadcrumb-current">{songName}</span>
    </nav>
  );
}

export default Breadcrumbs;
